module.exports = __webpack_public_path__ + "img/logo.97cfdaf3.png";